'use strict';

module.exports = require('./AutosuggestContainer').default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-autosuggest/dist/index.js
 ** module id = 676
 ** module chunks = 0
 **/